/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Order_By_IdInputs */



/**
* | output |
* | --- |
* | "Id" |
*
* @param {Merge_Event_Group_Order_By_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_order_by_id = /** @type {((inputs?: Merge_Event_Group_Order_By_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Order_By_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausweis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Id")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Identificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहचान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eu ia")
	return /** @type {LocalizedString} */ ("Id")
});